module.exports = __webpack_public_path__ + "static/img/spring_ganPic.1f65e383.png";